import { cellToBoundary } from "h3-js";
import { W_THRESH, type IncidentView } from "../screens/now/incident-model.js";

export interface IncidentFootprintProps {
  subject: string;
  hazard: string;
  confirmed: boolean; // corroboration weight W ≥ W_THRESH (3.0)
}

export interface FootprintFeature {
  type: "Feature";
  geometry: { type: "Polygon"; coordinates: number[][][] };
  properties: IncidentFootprintProps;
}

export interface FootprintFC {
  type: "FeatureCollection";
  features: FootprintFeature[];
}

/** GeoJSON polygon for one H3 cell: closed ring, [lng,lat] order. */
function cellPolygon(cell: string, properties: IncidentFootprintProps): FootprintFeature {
  const ring = cellToBoundary(cell, true) as number[][]; // [[lng,lat],...] open ring
  return {
    type: "Feature",
    geometry: { type: "Polygon", coordinates: [[...ring, ring[0]]] }, // close it
    properties,
  };
}

/** One closed [lng,lat] polygon per affected H3 hazard cell across the active
 *  incidents. Each feature carries `confirmed` (corroboration weight W ≥ W_THRESH)
 *  so the map styles corroborated vs unverified footprints differently. Incidents
 *  with no cells contribute nothing. */
export function incidentFootprintFC(views: IncidentView[]): FootprintFC {
  const features: FootprintFeature[] = [];
  for (const v of views) {
    const props: IncidentFootprintProps = {
      subject: v.subject,
      hazard: v.hazard,
      confirmed: v.W >= W_THRESH,
    };
    for (const c of v.cells) features.push(cellPolygon(c, props));
  }
  return { type: "FeatureCollection", features };
}
